export type LocalePrefixConfig = {
    code: string;
    prefix: string;
};

function localeFromPathPrefix(requestUrl: URL, supportedLocalePrefixes: LocalePrefixConfig[]): string | undefined {
    if (!requestUrl.hostname.endsWith('.malt.com')) {
        return undefined;
    }

    const maybePrefix = requestUrl.pathname.startsWith('/') ? requestUrl.pathname.substring(1) : requestUrl.pathname;
    return supportedLocalePrefixes.find(({prefix}) => maybePrefix === prefix || maybePrefix.startsWith(`${prefix}/`))?.code;
}

export function hostSettingsUrl(requestUrl: URL, supportedLocalePrefixes: LocalePrefixConfig[]): string {
    const locale = localeFromPathPrefix(requestUrl, supportedLocalePrefixes);
    if (!locale) {
        return '/api/host-settings/current';
    }

    return `/api/host-settings/current?locale=${encodeURIComponent(locale)}`;
}
